// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"8bd16c69","84":"32d4572a","140":"8b4b00b5","500":"1a68a356","787":"1d63fa92"}[chunkId] + ".chunk.js";
};